import { CheckCircleIcon } from "@heroicons/react/20/solid";

const AlertGreen = ({ title, message }) => {
  return (
    <div className={`rounded-md bg-signal-green-50 p-4`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <CheckCircleIcon
            aria-hidden="true"
            className={"h-5 w-5 text-signal-green-500"}
          />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium text-accent-700`}>{title}</h3>
          <div className={`mt-2 text-sm text-accent-700`}>
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertGreen;
